
import { mapGetters } from 'vuex'
export default {
    data() {
        return {
            dragXStart: 0,
            promotionItemWidth: 310,
            checkInterest: false,
        }
    },
    computed: {
        ...mapGetters({
            promotionGetter: 'cms/promotion',
        }),
        promotion() {
            return this.promotionGetter(this.$config.THEME)
        },
    },
    methods: {
        onIntersect(entries, observer) {
            const interesting = entries[0]?.isIntersecting
            if (interesting) {
                this.checkInterest = true
            }
        },
        onNext() {
            window.document.getElementById('next-promotions-button').click()
        },
        onBack() {
            window.document.getElementById('back-promotions-button').click()
        },
        evtDragStart(evt) {
            this.dragXStart = evt?.clientX
        },
        evtDragEnd(evt) {
            const dragXEnd = evt?.clientX
            if (dragXEnd > this.dragXStart) {
                this.onBack()
            } else if (dragXEnd < this.dragXStart) {
                this.onNext()
            }
            this.dragXStart = 0
        },
        getPromotionContentWidth() {
            const client = process.client
            if (client) {
                // Get promotion content width when size change
                const val = this.$refs?.refPromotion?.clientWidth
                if (val) {
                    // Display only 4 card if more than that should click arrow right icon above
                    // this.promotionItemWidth = Math.ceil(val / 4) - 14 // original
                    this.promotionItemWidth = Math.ceil(val / 4) + 50
                }
            } else {
                setTimeout(() => {
                    this.getPromotionContentWidth()
                }, 1000)
            }
        },
    },
}
